import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Services from './pages/Services.jsx';
import CaseStudies from './pages/CaseStudies.jsx';
//import { scan } from "react-scan"; // must be imported before React and React DOM

//scan({
//  enabled: true,
//});
const TEXT_SCALE_MAP = {
  base: 100,
  large: 108,
  larger: 116,
  largest: 124,
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const THEME_STORAGE_KEY = 'tapptiq-theme';

const getInitialTheme = () => {
  if (typeof window === 'undefined') return 'light';
  try {
    const storedTheme = window.localStorage?.getItem(THEME_STORAGE_KEY);
    if (storedTheme === 'dark' || storedTheme === 'light') {
      document.body.setAttribute('data-theme', storedTheme);
      document.documentElement.setAttribute('data-theme', storedTheme);
      document.documentElement.style.colorScheme = storedTheme;
      return storedTheme;
    }
  } catch (error) {
    console.warn('Theme preference unavailable; falling back to defaults.', error);
  }
  const existing = document.body.getAttribute('data-theme') || document.documentElement.getAttribute('data-theme');
  if (existing) {
    const normalized = existing === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', normalized);
    document.documentElement.style.colorScheme = normalized;
    return normalized;
  }
  document.body.setAttribute('data-theme', 'light');
  document.documentElement.setAttribute('data-theme', 'light');
  document.documentElement.style.colorScheme = 'light';
  return 'light';
};

function App() {
  const location = useLocation();
  const [theme, setThemeState] = useState(getInitialTheme);
  const [accessibility, setAccessibility] = useState({
    textSize: 'base',
    highContrast: false,
    reduceMotion: false,
  });

  useLayoutEffect(() => {
    document.body.setAttribute('data-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.style.colorScheme = theme === 'dark' ? 'dark' : 'light';
  }, [theme]);

  const setTheme = useCallback((nextTheme) => {
    setThemeState(nextTheme);
    try {
      window.localStorage?.setItem(THEME_STORAGE_KEY, nextTheme);
    } catch (error) {
      console.warn('Unable to persist theme preference.', error);
    }
  }, []);

  useEffect(() => {
    document.body.dataset.textSize = accessibility.textSize;
    document.body.dataset.highContrast = accessibility.highContrast;
    document.body.dataset.reduceMotion = accessibility.reduceMotion;

    const root = document.documentElement;
    root.dataset.textSize = accessibility.textSize;
    root.dataset.highContrast = accessibility.highContrast;
    root.dataset.reduceMotion = accessibility.reduceMotion;
    root.style.setProperty(
      '--accessibility-root-font-size',
      `${TEXT_SCALE_MAP[accessibility.textSize] || TEXT_SCALE_MAP.base}%`,
    );
  }, [accessibility]);

  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  return (
    <Layout
      theme={theme}
      setTheme={setTheme}
      accessibility={accessibility}
      setAccessibility={setAccessibility}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/CaseStudies" element={<CaseStudies />} />
      </Routes>
    </Layout>
  );
}

export default App;
